import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";

export default {
  Email: {
    Label: AppCatalog.Field.Email.Label + " Penerima " + AppModule.LowStock.FullName,
    Type: AppCatalog.Field.Email.Type,
    MaxLength: 100,
    Valid: true
  }
}